import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const defaultIds = (c) => ({
  regId: c?.registrations?.length === 1 ? c.registrations[0].id : null,
  siteId: c?.sites?.length === 1 ? c.sites[0].id : null,
});

export function RegSitePicker({ customer, ids, onChange }) {
  const regs = customer?.registrations || [];
  const sites = customer?.sites || [];
  return (
    <>
      <div>
        <Label>Billing registration (GSTIN){regs.length > 1 && " *"}</Label>
        {regs.length ? (
          <Select value={ids.regId || ""} onValueChange={(v) => onChange({ ...ids, regId: v })}>
            <SelectTrigger className="bg-white" data-testid="order-registration-select"><SelectValue placeholder="Pick GSTIN" /></SelectTrigger>
            <SelectContent>
              {regs.map((r) => <SelectItem key={r.id} value={r.id} data-testid={`registration-option-${r.gstin || r.id}`}>{r.gstin || "No GSTIN"}{r.label ? ` · ${r.label}` : ""}{r.state ? ` · ${r.state}` : ""}</SelectItem>)}
            </SelectContent>
          </Select>
        ) : <p className="text-xs text-amber-700 mt-2" data-testid="order-no-registration-note">No GST registration in master yet — order will be “GST pending”.</p>}
      </div>
      <div>
        <Label>Delivery site{sites.length > 1 && " *"}</Label>
        {sites.length ? (
          <Select value={ids.siteId || ""} onValueChange={(v) => onChange({ ...ids, siteId: v })}>
            <SelectTrigger className="bg-white" data-testid="order-site-select"><SelectValue placeholder="Pick delivery site" /></SelectTrigger>
            <SelectContent>
              {sites.map((s) => <SelectItem key={s.id} value={s.id} data-testid={`site-option-${s.id}`}>{s.name}{s.city ? ` · ${s.city}` : ""}</SelectItem>)}
            </SelectContent>
          </Select>
        ) : <p className="text-xs text-slate-500 mt-2" data-testid="order-no-site-note">No delivery sites in master.</p>}
      </div>
    </>
  );
}
